export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_label_userPaymentRequestNo') || '请款单号',
    field: 'userPaymentRequestNo',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_userPaymentRequestStatus') || '单据状态',
    field: 'userPaymentRequestStatus',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'userPaymentRequestStatus' },
  },
  {
    title: that.$l('table_label_salesPersonName') || '申请人',
    field: 'salesPersonName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_saleDepName') || '申请人部门',
    field: 'saleDepName',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_requestDate') || '申请日期',
    field: 'requestDate',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_archiveDate') || '申请日期',
    field: 'archiveDate',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_expensePayerName') || '申请公司',
    field: 'expensePayerName',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_currencyAmount') || '请款金额',
    field: 'currencyAmount',
    minWidth: 100,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_currencyUnit') || '货币单位',
    field: 'currencyUnitText',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_rmbAmount') || '人民币金额',
    field: 'rmbAmount',
    width: 100,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_costDepName') || '分摊部门',
    field: 'costDepName',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_custName') || '费用客户',
    field: 'custName',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_custOrderNo') || '客户订单号',
    field: 'custOrderNo',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_customsNo') || '外运编号',
    field: 'customsNo',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_brand') || '品牌',
    field: 'brandName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_expenseName') || '费用项目',
    field: 'expenseName',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_expenseType') || '财务费用',
    field: 'expenseTypeText',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_substituteInvoice') || '代用发票',
    field: 'substituteInvoice',
    width: 80,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_originalExpenseType') || '原始费用项目',
    field: 'originalExpenseTypeText',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_paymentMethod') || '付款方式',
    field: 'paymentMethodText',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_remark') || '付款用途',
    field: 'remark',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_description') || '付款说明',
    field: 'description',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_notes') || '备注',
    field: 'notes',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_payeeType') || '收款方',
    field: 'payeeTypeText',
    width: 100,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_payeeName') || '收款单位',
    field: 'payeeName',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_bankName') || '开户银行',
    field: 'bankName',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_bankAccountName') || '账户名称',
    field: 'bankAccountName',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_bankAccountNo') || '银行账号',
    field: 'bankAccountNo',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
